export const MEJS_PLAYER_INITIALIZED = 'MEJS_PLAYER_INITIALIZED';
export const NAV_ITEM_CLICK = 'NAV_ITEM_CLICK';

export const FETCH_MANIFEST_REQUEST = 'FETCH_MANIFEST_REQUEST';
export const FETCH_MANIFEST_SUCCESS = 'FETCH_MANIFEST_SUCCESS';
export const FETCH_MANIFEST_FAILURE = 'FETCH_MANIFEST_FAILURE';



// WEBPACK FOOTER //
// ./src/actions/types.js